import { Button } from '@material-ui/core';
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import en from '../../../../lang/en-us';
import { TableColumn, TableWithCollapse } from '../../../../lib/DataTable';
import { RootStateType } from '../../../../redux-store/reducers';
import { fetchInvestorDetails } from '../../../../redux-store/actions/nct';
import { LIST_PROTFOLIO_PAYLOAD } from '../../../../redux-store/types/portfolio';
import {
    BANK_DETAILS_WITH_NO_IFSC,
    getIFSCDetails,
    portfoliosByMinorStatus,
    portfoliosByModeOfHolding,
    portfoliosByTransactionResource,
    portfoliosWithNoIfsc,
} from '../../portfolios/utils';
import NoFoliosFound from '../NoFoliosFound';
import { DEBT, EQUITY, LIQUID, OTHER, UPDATE_IFSC } from '../../../../utils/constants';
import { useTableWithCollapse } from '../../../../lib/DataTable/customHooks';
import { ActionHeader, FaqLink } from '..';
import { NFT_TRXN_TYPE_MAP } from '../../commercial/utils';
import { PanSeedCheckNew } from '../../../common/PanSeedCheckNew';
const { dashboard } = en;

export const UpdateIFSCColumns: TableColumn[] = [
    {
        field: 'id',
        headerName: 'Folio',
    },
    {
        field: 'amcName',
        headerName: 'Fund House',
        valueGetter: ({ row }) => {
            return row.amcName ? row.amcName : 'NA';
        },
        width: 250,
        filterBy: true,
    },
    {
        field: 'name',
        headerName: 'BANK NAME',
        width: 250,
    },
    {
        field: 'branch',
        headerName: 'BRANCH',
        valueGetter: ({ row }) => {
            return row.branch ? row.branch : 'NA';
        },
        width: 150,
    },
    {
        field: 'ifsc',
        headerName: 'IFSC',
        valueGetter: ({ row }) => {
            return row.ifsc ? row.ifsc : 'NA';
        },
        width: 200,
    },
    {
        field: 'accountNo',
        headerName: 'ACCOUNT NO.',
        width: 150,
    },
    {
        isFilter: true,
        field: 'assetType',
        headerName: 'Category',
        filterBy: true,
        renderStaticFilters: [EQUITY, LIQUID, DEBT, OTHER],
    },
];

function UpdateIFSC(props: any) {
    const [rowData, setRowData] = useState<any[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const {
        selectedRows: targetFunds,
        setSelectedRows: setTargetFunds,
        resetTable,
        tableColumns,
        tableRows,
        resetFilters,
        ...filters
    } = useTableWithCollapse<BANK_DETAILS_WITH_NO_IFSC[]>({
        rows: rowData,
        columns: UpdateIFSCColumns,
        loading,
    });

    useEffect(() => {
        setLoading(true);
        async function callApi() {
            const payload: LIST_PROTFOLIO_PAYLOAD = {
                pan: props.pan,
                mobile: props.mobile,
                pekrn: props.pekrn,
                reqId: props.reqId,
            };

            try {
                const { body: investorDetails = {} } = await props.fetchInvestorDetails(payload);
                const { success: ifscDetails = [] } = investorDetails;
                const ifscRowData = getIFSCDetails(ifscDetails, [
                    portfoliosByTransactionResource,
                    portfoliosByModeOfHolding,
                    portfoliosByMinorStatus,
                ]);
                setRowData(ifscRowData);
            } catch (err: any) {
                alert(err.message);
            } finally {
                setLoading(false);
            }
        }
        callApi();
        return () => {};
    }, []);

    const _isRowSeletable = ({ row }: { row: BANK_DETAILS_WITH_NO_IFSC }) => {
        if (targetFunds.length) {
            const [fund] = targetFunds;
            if (fund.accountNo === row.accountNo) {
                return true;
            }
            return false;
        }
        return true;
    };

    const _toolTipGetText = ({ row }: { row: BANK_DETAILS_WITH_NO_IFSC }) => {
        if (targetFunds.length) {
            const [fund] = targetFunds;
            if (fund.accountNo !== row.accountNo) {
                return dashboard.UpdateIFSC.toolTipInfo.info;
            }
        }
        return '';
    };

    const handleSubmit = () => {
        props.history.push('/portal/nct/update-ifsc-details', { targetFunds });
    };

    const [callPanSeed, setCallPanSeed] = useState(false);

    const resetTrigger = () => {
        setCallPanSeed(false);
    };

    return (
        <div className="curved-bg">
            <ActionHeader header={dashboard.UpdateIFSC.UpdateIFSCHeading} />
            <PanSeedCheckNew
                callBackFn={handleSubmit}
                foliosArray={targetFunds}
                trxnType={NFT_TRXN_TYPE_MAP.updateBankIFSC}
                triggerCheck={callPanSeed}
                goBack={false}
                resetTrigger={resetTrigger}
            />
            <div className="curved-bg-content curved-bg-table-outer">
                <div className="curved-bg-content-table">
                    <h5> {dashboard.UpdateIFSC.UpdateIFSCInfo}</h5>
                    <div
                        className="curved-table-content"
                        tabIndex={0}
                        aria-label="Update IFSC folios list"
                    >
                        {loading || !!tableRows.length ? (
                            <TableWithCollapse
                                rows={tableRows}
                                columns={tableColumns}
                                isRowSelectable={_isRowSeletable}
                                toolTipTextGetter={_toolTipGetText}
                                selectedRows={targetFunds}
                                setSelectedRows={setTargetFunds}
                                checkBoxEnabled
                                toolTipEnabled
                                disableAllSelection
                                resetFilters={resetFilters}
                                {...filters}
                            />
                        ) : (
                            <NoFoliosFound info={'No Folios Found'} />
                        )}
                    </div>
                    <FaqLink section={UPDATE_IFSC} history={props.history} />
                </div>
                <div className="curved-bg-content-inner-bottom">
                    {!!rowData.length && (
                        <div className="table-submit">
                            <Button
                                onClick={() => setCallPanSeed(true)}
                                className="customBtn"
                                disabled={!targetFunds.length}
                            >
                                {dashboard.UpdateIFSC.buttonText}
                            </Button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default connect(({ authReducer }: RootStateType) => ({ ...authReducer }), {
    fetchInvestorDetails,
})(UpdateIFSC);
